import posthog from 'posthog-js';

interface TrackEventOptions {
    tags?: string[];
    properties?: Record<string, unknown>;
}

export type DataLayerWindow = Window & {
    dataLayer?: Array<Record<string, unknown>>;
};

export function trackEvent(eventName: string, options: TrackEventOptions = {}) {
    if (import.meta.env.DEV) {
        return;
    }

    const { tags, properties } = options;

    const payload: Record<string, unknown> = { ...(properties ?? {}) };

    if (tags && tags.length > 0) {
        payload.tags = tags;
    }

    posthog.capture(eventName, payload);
}

export function pushDataLayerEvent(eventName: string, enabled = true) {
    if (!enabled || typeof window === 'undefined') {
        return;
    }

    const dataLayerWindow = window as DataLayerWindow;
    dataLayerWindow.dataLayer ??= [];
    dataLayerWindow.dataLayer.push({ event: eventName });
}
